import React, { useContext } from 'react';
import { DropdownContext } from './DropdownContext.es.js';
import { styled } from '@teko/ds-desktop';
import { Popper } from '../Popper/Popper.es.js';

const StyledDiv = styled.div(({ show }) => `
    background-color: transparent;
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = styled(Popper)(({ show }) => `
    visibility: ${show ? 'visible' : 'hidden'};
    z-index: 999;
  `);
const DropdownMenu = ({ children, popperConfig, placement = 'bottom-start', origin = 'center top', className, }) => {
    const { state: { isOpen, referenceElement }, } = useContext(DropdownContext);
    return (React.createElement(StyledPopper, { className: className, referenceElement: referenceElement, popperConfig: popperConfig, placement: placement, show: isOpen },
        React.createElement(StyledDiv, { show: isOpen, origin: origin }, children)));
};

export { DropdownMenu };
